module.exports = __webpack_public_path__ + "img/logo_certiprof.27243af7.jpg";